import React from "react";

const Audius = ({ className, width, height }) => {
    const w = (typeof width !== 'undefined') ? width : 32;
    const h = (typeof height !== 'undefined') ? width : 32;
    return (
        <svg className={className} id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 600 500" width={`${w}px`} height={`${h}px`}><defs></defs><path d="M558.69,465,434.78,250,376.66,149.21,310.86,35.07a12.4,12.4,0,0,0-21.48,0L165.18,249.84,114.43,337.6a12.41,12.41,0,0,0,10.74,18.62l95.87.06a12.43,12.43,0,0,0,10.75-6.19l49.82-86.18,7.62-13.18a13.36,13.36,0,0,1,1-1.46,12.41,12.41,0,0,1,20.5,1.48l51.7,89.68L372,357a13.25,13.25,0,0,1,1.22,2.91,12.41,12.41,0,0,1-12,15.69l-112.78-.07a12.43,12.43,0,0,0-10.75,6.19l-48,83a12.4,12.4,0,0,0,10.73,18.61l99.39.07,123.93.08,124.18.08A12.4,12.4,0,0,0,558.69,465Z" /></svg>
    )
}


export default Audius